import { render, staticRenderFns } from "./VSelectTags.vue?vue&type=template&id=c0d42556&"
import script from "./VSelectTags.vue?vue&type=script&lang=js&"
export * from "./VSelectTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports